export enum REDUCER_NAMES {
    registration = 'registration',
    fundsTransfer = 'fundsTransfer',
    responsibleGaming = 'responsibleGaming',
    floatSearch = 'floatSearch',
    postCode = 'postCode',
    clubs = 'clubs',
    recentlyGames = 'recentlyGames',
    tournaments = 'tournaments',
}
